export default {
  buttons: {
    cancel: "ยกเลิก",
    dismiss: "ปิด",
    add_waypoint: "เพิ่มจุดหมายปลายทาง"
  },
  distance: {
    value: "{distance, number, distance} {unit}",
    unit: {
      miles: "ไมล์"
    }
  },
  search: {
    title: "ค้นหา",
    placeholder: "ระบุตำแหน่งที่ตั้ง",
    enter_location: "ระบุตำแหน่งที่ตั้ง",
    help: {
      inactive: "ค้นหา"
    }
  },
  filters: {
    title: "เลือกข้อมุล",
    amenities: {
      title: "บริการ และสิ่งอำนวยความสะดวก"
    },
    fuels: {
      title: "ประเภทน้ำมัน"
    }
  },
  directions: {
    title: "วางแผนเส้นทาง",
    placeholder: {
      destination: "ระบุตำแหน่งที่ตั้ง",
      waypoint: "ระบุตำแหน่งที่ตั้ง"
    },
    route: {
      title: "ตัวเลือก",
      avoid_tolls: "หลีกเลี่ยงค่าธรรมเนียม",
      avoid_highways: "หลีกเลี่ยงทางหลวง",
      title_corridor: "ระยะทางถึงสถานีบริการ "
    },
    travel_time: `\
{weeks, plural, =0 {} =1 {# wk} other {# wks}}
{days, plural, =0 {} =1 {# วัน} other {# วัน}}
{hours, plural, =0 {} =1 {# hr} other {# hrs}}
{minutes, plural, =0 {} =1 {# นาที} other {# นาที}}\
`,
    button: "ค้นหา"
  },
  locations: {
    title: "ตำแหน่งที่ตั้ง",
    distance: "{distance, number, distance} {unit}",
    distance_from: "{distance, number, distance} {unit} ถึง {place}"
  },
  info_window: {
    title: "ข้อมูลสถานีบริการ",
    services: "บริการ และสิ่งอำนวยความสะดวก",
    nearby: "ใกล้เคียง",
    opening_hours: {
      period: "{start, time, short} – {end, time, short}"
    },
    fuel_prices: {
      price: "{price, number, fuelPrice}",
      last_updated_on: "ข้อมูลล่าสุด",
      timestamp: "{timestamp, date, dateFormat}"
    }
  },
  itinerary: {
    title: "วางแผนเส้นทาง"
  },
  fuels: {
    fuelsave_regular_diesel: "เชลล์ ฟิวเซฟ ดีเซล",
    low_octane_gasoline: "เชลล์ ฟิวเซฟ แก๊สโซฮอล์ 91",
    midgrade_gasoline: "เชลล์ E20 แก๊สโซฮอล์",
    premium_diesel: "เชลล์ วี-เพาเวอร์ ไนโตร+  ดีเซล",
    premium_gasoline: "เชลล์ วี-เพาเวอร์ ไนโตร+ แก๊สโซฮอล์ 95"
  },
  amenities: {
    air_and_water: "เติมลม",
    atm: "x",
    bank_note_acceptor: "ตู้ฝากเงินอัตโนมัติ",
    cafe: "ร้านอาหาร",
    carwash: "ล้างรถ",
    costa_express: "ร้านสะดวกซื้อ",
    credit_card_american_express: "บัครเครดิตอมเริกัน เอ็กซ์เพรส",
    credit_card_diners_club: "บัครเครดิต Diners",
    credit_card_mastercard: "บัตรเครดิต มาสเตอร์คาร์ด",
    credit_card_visa: "บัตรเครดิต วีซ่า",
    credit_card: "เครดิตคาร์ด",
    fleet_card_dkv: "บัตรฟลีทคาร์ด- DKV",
    fleet_card_eni: "บัตรฟลีทคาร์ด- Eni",
    fleet_card_esso: "บัตรฟลีทคาร์ด- Esso",
    fleet_card_general: "บัตรฟลีทคาร์ด",
    fleet_card_uta: "บัตรฟลีทคาร์ด- UTA",
    full_service: "ให้บริการเต็มรูปแบบ",
    hgv_lane: "สำหรับรถบรรทุก",
    high_speed_diesel_pump: "น้ำมันดีเซลหมุนเร็ว",
    hot_food: "อาหารจานด่วน",
    ido_ticket: "จำหน่ายตั๋วออนไลน์",
    parking_lanes: "ลานจอดรถ",
    pay_at_pump: "เคาเตอร์เซอร์วิส",
    quick_lubes: "เปลี่ยนถ่ายน้ำมันเครื่อง",
    restaurant: "ร้านอาหาร",
    self_service: "บริการตนเอง",
    service_bay: "บริการเปลี่ยนถ่ายน้ำมันเครื่อง",
    shop: "ร้านค้า",
    shower: "ห้องอาบน้ำ",
    standard_toilet: "ห้องน้ำ",
    toilet: "ห้องน้ำ",
    truck_parking: "มีที่จอดรถบรรทุก",
    truckport: "รถบรรทุกเท่านั้น",
    twenty_four_hour: "เปิดบริการ 24 ชั่วโมง",
    vacuum: "ดูดฝ่น"
  },
  settings: {
    title: "ตั้งค่า",
    tooltip: "ตั้งค่า",
    distance_units: {
      title: "ระยะทาง",
      km: "กิโลเมตร",
      miles: "ไมล์"
    },
    language: {
      title: "ภาษา"
    }
  }
}
